module.exports = __webpack_public_path__ + "img/Merika Coleman.05828d01.jpg";